module.exports = __webpack_public_path__ + "img/Dantam Bridal 27.1b2ce022.jpg";